import { render, staticRenderFns } from "./appManage.vue?vue&type=template&id=53e2771d&scoped=true"
import script from "./appManage.vue?vue&type=script&lang=js"
export * from "./appManage.vue?vue&type=script&lang=js"
import style0 from "./appManage.vue?vue&type=style&index=0&id=53e2771d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e2771d",
  null
  
)

export default component.exports